import * as React from 'react';
import {
    Button, Grid, Dialog,
    DialogActions,
    DialogContent
} from "@mui/material";
import {useEffect, useState} from "react";
import CancelButton from "./buttons/CancelButton";
import SaveButton from "./buttons/SaveButton";

import "./PlateNumberDialog.css";
import ClearButton from "./buttons/ClearButton";

export type PlateNumberDialogProps = {
    open: boolean;
    value?: string;
    onOk: (value: string) => void;
    onClose: () => void;
};

const PlateNumberDialog: React.FC<PlateNumberDialogProps> = (props) => {

    const provinces = ['京', '沪', '粤', '津', '冀', '晋', '蒙', '辽', '吉', '黑', '苏', '浙', '皖', '闽', '赣', '鲁', '豫', '鄂', '湘', '桂', '琼', '渝', '川', '贵', '云', '藏', '陕', '甘', '青', '宁', '新'];

    const alphabets = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    const numbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];

    const [inputIndex, setInputIndex] = useState(0);
    const [inputNumbers, setInputNumbers] = useState<Array<string>>([]);

    useEffect(() => {
        if (props.open) {
            // 画面打开的时候，把value的值进行解析填入相应的框
            const inputNumbers = [];

            let inputNumberLength = 0;
            if (props.value) {
                inputNumberLength = props.value.length >= 7 ? 7 : props.value.length;
                for (let i = 0; i <= inputNumberLength; i++) {
                    inputNumbers[i] = props.value.substring(i, i + 1);
                }
            }
            setInputNumbers(inputNumbers);
            setInputIndex(inputNumberLength);
        }
    }, [props.open]);

    const handleOk = () => {
        let inputNumberStr = "";
        for (let i = 0; i < inputNumbers.length; i++) {
            inputNumberStr = inputNumberStr + inputNumbers[i];
        }
        props.onOk(inputNumberStr);
        props.onClose();
    }

    const handleCancel = () => {
        props.onClose();
    }

    const handleClear = () => {
        setInputIndex(0);
        setInputNumbers([]);
    }

    const renderProvinceKeyboard = () => {
        return (
            <Grid container spacing={1}>
                {
                    provinces.map((item, index) => {
                        return <Grid item key={index}>
                            <Button size="small" variant="outlined" style={{minWidth: 'inherit'}}
                                    onClick={() => handleClickProvinceKeyboard(item)}>{item}</Button>
                        </Grid>
                    })
                }
            </Grid>
        )
    }

    const handleClickProvinceKeyboard = (item: string) => {
        inputNumbers[0] = item;
        setInputNumbers(inputNumbers);
        setInputIndex(1);
    }

    const renderAlphaNumberKeyboard = () => {
        return (
            <div>
                <Grid container spacing={1}>
                    {
                        numbers.map((item, index) => {
                            return <Grid item key={index}>
                                <Button size="small" variant="outlined" style={{minWidth: 'inherit'}}
                                        onClick={() => handleClickAlphaNumberKeyboard(item)}>{item}</Button>
                            </Grid>
                        })
                    }
                </Grid>
                <Grid container spacing={1} style={{marginTop: '2px'}}>
                    {
                        alphabets.map((item, index) => {
                            return <Grid item key={index}>
                                <Button size="small" variant="outlined" style={{minWidth: 'inherit'}}
                                        onClick={() => handleClickAlphaNumberKeyboard(item)}>{item}</Button>
                            </Grid>
                        })
                    }
                </Grid>
            </div>
        )
    }

    const handleClickAlphaNumberKeyboard = (item: string) => {
        const newInputNumbers = [...inputNumbers];
        newInputNumbers[inputIndex] = item;
        const nextInputIndex = inputIndex < 7 ? inputIndex + 1 : 7;
        setInputNumbers(newInputNumbers);
        setInputIndex(nextInputIndex);
    }

    return (
        <Dialog className={'vehicle-plate-number'} fullWidth={true} open={props.open}
                onClose={() => handleCancel()}
                aria-labelledby="form-dialog-title">
            <DialogContent>
                <div className={'vehicle-plate-number-input-container'}>
                    <div
                        className={'vehicle-plate-number-input ' + (inputIndex === 0 ? 'vehicle-plate-number-input-focus' : '')}
                        onClick={() => setInputIndex(0)}>{inputNumbers[0]}</div>
                    <div
                        className={'vehicle-plate-number-input ' + (inputIndex === 1 ? 'vehicle-plate-number-input-focus' : '')}
                        onClick={() => setInputIndex(1)}>{inputNumbers[1]}</div>
                    <span className={'vehicle-plate-number-split'}>.</span>
                    <div
                        className={'vehicle-plate-number-input ' + (inputIndex === 2 ? 'vehicle-plate-number-input-focus' : '')}
                        onClick={() => setInputIndex(2)}>{inputNumbers[2]}</div>
                    <div
                        className={'vehicle-plate-number-input ' + (inputIndex === 3 ? 'vehicle-plate-number-input-focus' : '')}
                        onClick={() => setInputIndex(3)}>{inputNumbers[3]}</div>
                    <div
                        className={'vehicle-plate-number-input ' + (inputIndex === 4 ? 'vehicle-plate-number-input-focus' : '')}
                        onClick={() => setInputIndex(4)}>{inputNumbers[4]}</div>
                    <div
                        className={'vehicle-plate-number-input ' + (inputIndex === 5 ? 'vehicle-plate-number-input-focus' : '')}
                        onClick={() => setInputIndex(5)}>{inputNumbers[5]}</div>
                    <div
                        className={'vehicle-plate-number-input ' + (inputIndex === 6 ? 'vehicle-plate-number-input-focus' : '')}
                        onClick={() => setInputIndex(6)}>{inputNumbers[6]}</div>
                    <div style={{backgroundColor: '#a5ffb4'}}
                         className={'vehicle-plate-number-input ' + (inputIndex === 7 ? 'vehicle-plate-number-input-focus' : '')}
                         onClick={() => setInputIndex(7)}>{inputNumbers[7]}</div>
                </div>

                <div style={{marginTop: '20px'}}>
                    {inputIndex === 0 ? renderProvinceKeyboard() : renderAlphaNumberKeyboard()}
                </div>
            </DialogContent>
            <DialogActions>
                <ClearButton onClick={handleClear}/>
                <CancelButton onClick={handleCancel}/>
                <SaveButton onClick={handleOk}/>
            </DialogActions>
        </Dialog>
    );
}

export default PlateNumberDialog;